import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'

import ImagePreviews from '../image-preview/ImagePreviews'

export default class PortalImageStoreModal extends Component {
  static propTypes = {
    params: PropTypes.shape({
      storeImages: PropTypes.array.isRequired,
    }),
    onRequestClose: PropTypes.func.isRequired,
  }

  handleImageSelect = imageID => {
    if (this.props.onRequestClose) {
      this.props.onRequestClose({ imageID })
    }
  }

  render() {
    const { storeImages } = this.props.params
    if (!_.isEmpty(storeImages))
      return (
        <div className="card">
          <header className="card-header">
            <p className="card-header-title">เลือกรูปภาพที่จะแทนที่ ?</p>
          </header>
          <div className="card-content">
            <div className="content">
              <ImagePreviews
                images={storeImages}
                isImagePreviewRemoveBtn={false}
                onImageSelect={this.handleImageSelect}
                imageIDPath="mainImageId"
              />
            </div>
          </div>
          <footer className="card-footer">
            <a
              className="card-footer-item button is-white"
              onClick={this.props.onRequestClose}
            >
              ยกเลิก
            </a>
          </footer>
        </div>
      )
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/templates/portal-image-store/PortalImageStoreModal.js